.sectionHeading {
  margin-top: 16px;
  margin-bottom: 16px;
}

.featuresCaption {
  padding-bottom: 16px;
  display: block;
}

.radioGroup {
  padding-left: 16px;
}

.autoForm {
  padding-left: 16px;
}
